var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlinedCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.669 422.912c.036-.548.061-1.1.061-1.658s-.026-1.135-.064-1.7a25.024 25.024 0 00-24.271-23.286c-.221-.006-.442-.017-.665-.017-.256 0-.509.012-.764.019a25.028 25.028 0 00-24.2 23.695q-.033.639-.033 1.286t.033 1.286a25 25 0 0049.906.372zm-24.939 19.342a21 21 0 1121-21 21.024 21.024 0 01-21 21z",
    transform: "translate(-272.73 -396.254)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.78 411.75l-14.825 13.691-7.559-6.415-2.577 3.054 10.091 9.12 17.738-16.345z",
    transform: "translate(-272.73 -396.254)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedCorrect);
export default __webpack_public_path__ + "static/media/outlined-correct.c24c37a6b8ddfd428c661dff778e7f73.svg";
export { ForwardRef as ReactComponent };